module.exports = __webpack_public_path__ + "img/st-cb6-1-111.cf4509a8.gif";